/**
 * DevExtreme (esm/__internal/grids/grid_core/editing/const.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import Scrollable from "../../../../ui/scroll_view/ui.scrollable";
export var EDITOR_CELL_CLASS = "dx-editor-cell";
export var ROW_CLASS = "dx-row";
export var CELL_MODIFIED_CLASS = "dx-cell-modified";
export var ROW_SELECTED_CLASS = "dx-selection";
export var EDIT_FORM_CLASS = "edit-form";
export var DATA_EDIT_DATA_INSERT_TYPE = "insert";
export var DATA_EDIT_DATA_REMOVE_TYPE = "remove";
export var EDITING_POPUP_OPTION_NAME = "editing.popup";
export var EDITING_FORM_OPTION_NAME = "editing.form";
export var EDITING_EDITROWKEY_OPTION_NAME = "editing.editRowKey";
export var EDITING_EDITCOLUMNNAME_OPTION_NAME = "editing.editColumnName";
export var TARGET_COMPONENT_NAME = "targetComponent";
export var EDITORS_INPUT_SELECTOR = "input:not([type='hidden'])";
export var FOCUSABLE_ELEMENT_SELECTOR = "[tabindex]:not([disabled]), ".concat(EDITORS_INPUT_SELECTOR, ":not([disabled])");
export var EDIT_MODE_BATCH = "batch";
export var EDIT_MODE_ROW = "row";
export var EDIT_MODE_CELL = "cell";
export var EDIT_MODE_FORM = "form";
export var EDIT_MODE_POPUP = "popup";
export var FIRST_NEW_ROW_POSITION = "first";
export var LAST_NEW_ROW_POSITION = "last";
export var PAGE_BOTTOM_NEW_ROW_POSITION = "pageBottom";
export var PAGE_TOP_NEW_ROW_POSITION = "pageTop";
export var VIEWPORT_BOTTOM_NEW_ROW_POSITION = "viewportBottom";
export var VIEWPORT_TOP_NEW_ROW_POSITION = "viewportTop";
export var EDIT_MODES = [EDIT_MODE_BATCH, EDIT_MODE_ROW, EDIT_MODE_CELL, EDIT_MODE_FORM, EDIT_MODE_POPUP];
export var ROW_BASED_MODES = [EDIT_MODE_ROW, EDIT_MODE_FORM, EDIT_MODE_POPUP];
export var CELL_BASED_MODES = [EDIT_MODE_BATCH, EDIT_MODE_CELL];
export var REQUIRED_EDITOR_LABELLEDBY_MODES = [EDIT_MODE_BATCH, EDIT_MODE_ROW, EDIT_MODE_CELL];
export var MODES_WITH_DELAYED_FOCUS = [EDIT_MODE_ROW, EDIT_MODE_FORM];
export var READONLY_CLASS = "readonly";
export var LINK_CLASS = "dx-link";
export var LINK_ICON_CLASS = "dx-link-icon";
export var ROW_SELECTED = "dx-selection";
export var EDIT_BUTTON_CLASS = "dx-edit-button";
export var COMMAND_EDIT_CLASS = "dx-command-edit";
export var COMMAND_EDIT_WITH_ICONS_CLASS = "".concat(COMMAND_EDIT_CLASS, "-with-icons");
export var INSERT_INDEX = "__DX_INSERT_INDEX__";
export var ROW_INSERTED = "dx-row-inserted";
export var ROW_MODIFIED = "dx-row-modified";
export var CELL_MODIFIED = "dx-cell-modified";
export var EDITING_NAMESPACE = "dxDataGridEditing";
export var CELL_FOCUS_DISABLED_CLASS = "dx-cell-focus-disabled";
export var DATA_EDIT_DATA_UPDATE_TYPE = "update";
export var DEFAULT_START_EDIT_ACTION = "click";
export var EDIT_LINK_CLASS = {
    save: "dx-link-save",
    cancel: "dx-link-cancel",
    edit: "dx-link-edit",
    undelete: "dx-link-undelete",
    delete: "dx-link-delete",
    add: "dx-link-add"
};
export var EDIT_ICON_CLASS = {
    save: "save",
    cancel: "revert",
    edit: "edit",
    undelete: "revert",
    delete: "trash",
    add: "add"
};
export var METHOD_NAMES = {
    edit: "editRow",
    delete: "deleteRow",
    undelete: "undeleteRow",
    save: "saveEditData",
    cancel: "cancelEditData",
    add: "addRowByRowIndex"
};
export var ACTION_OPTION_NAMES = {
    add: "allowAdding",
    edit: "allowUpdating",
    delete: "allowDeleting"
};
export var BUTTON_NAMES = ["edit", "save", "cancel", "delete", "undelete"];
export var EDITING_CHANGES_OPTION_NAME = "editing.changes";
export var FOCUS_OVERLAY_CLASS = "focus-overlay";
export var ADD_ROW_BUTTON_CLASS = "addrow-button";
export var DROPDOWN_EDITOR_OVERLAY_CLASS = "dx-dropdowneditor-overlay";
export var DATA_ROW_CLASS = "dx-data-row";
export var ROW_REMOVED = "dx-row-removed";
export var FILTER_ROW_CLASS = "filter-row";
var isRenovatedScrollable = !!Scrollable.IS_RENOVATED_WIDGET;
export var EDIT_FORM_ITEM_CLASS = "edit-form-item";
export var EDIT_POPUP_CLASS = "edit-popup";
export var EDIT_POPUP_FORM_CLASS = "edit-popup-form";
export var FOCUSABLE_ELEMENT_CLASS = isRenovatedScrollable ? "dx-scrollable" : "dx-scrollable-container";
export var BUTTON_CLASS = "dx-button";
export var FORM_BUTTONS_CONTAINER_CLASS = "form-buttons-container";
export var EDIT_ROW = "dx-edit-row";
